// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1788":"d065f51e","1890":"a5543a89","2693":"d065f51e","5334":"a5543a89","9236":"a5543a89","9282":"2ccc8c24","9328":"a5543a89","9774":"d065f51e"}[chunkId] + ".chunk.css";
};